import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './About.css';

const About: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <header className="about-header">
        <button className="back-button" onClick={() => navigate('/profile')}>
          ←
        </button>
        <h1>About</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="about-content">
        <div className="about-card">
          <div className="app-logo-large">
            <span className="spark">Spark</span>
            <span className="ademy">ademy</span>
          </div>
          <p className="app-version">Version 1.0.0</p>
        </div>

        <div className="about-section">
          <h3>About Sparkademy</h3>
          <p>
            Sparkademy is your gateway to quality education and learning resources. 
            We provide a comprehensive platform for students to access courses, books, 
            and online learning sessions.
          </p>
        </div>

        <div className="about-section">
          <h3>Our Mission</h3>
          <p>
            To make quality education accessible to everyone, anywhere, anytime. 
            We believe in empowering students through knowledge and continuous learning.
          </p>
        </div>

        <div className="about-section">
          <h3>Contact Us</h3>
          <p>Email: support@sparkademy.com</p>
          <p>Phone: +961 70 123 456</p>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default About;

